import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const TaxonomyList = React.lazy(() => import('components/Taxonomy/List/List'));

function ScreensTaxonomyList() {
  return (
    <BaseLayout>
      <DocumentTitle>Taxonomy Management</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <TaxonomyList />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensTaxonomyList;
